{
  "familyId": "MET-TIJD-METEN",
  "questions": [
    {
      "id": "MET-TIJD-METEN-001",
      "familyId": "MET-TIJD-METEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijd_meten",
      "subSkill": "tijd_meten_stopwatch",
      "questionType": "multiple_choice",
      "question": "De stopwatch toont 01:23. Hoeveel seconden is dat in totaal?",
      "options": ["83 seconden", "123 seconden", "63 seconden", "143 seconden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stopwatch aflezen",
            "content": "01:23 betekent 1 minuut en 23 seconden. 1 minuut = 60 seconden. Dus: 60 + 23 = 83 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_meten_aflezen",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "01:23 = 1 minuut en 23 seconden. 1 minuut = 60 seconden. Dus: 60 + 23 = 83 seconden totaal. Waarom 60? Omdat er altijd 60 seconden in 1 minuut gaan. Check: 83 seconden = 1 minuut en 23 seconden ✓",
        "solutionSteps": [
          "Lees af: 01:23 = 1 minuut en 23 seconden",
          "Reken om: 1 minuut = 60 seconden",
          "Tel op: 60 + 23 = 83 seconden",
          "Check: 83 = 60 + 23 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1 × 60 + 23 = 83 seconden.",
          "1": "Je dacht waarschijnlijk dat je de cijfers achter elkaar leest: 1-2-3 = 123. Maar 01:23 is 1 minuut en 23 seconden. Reken de minuten om: 1 × 60 + 23 = 83. Onthoud: de dubbele punt scheidt minuten van seconden.",
          "2": "Je dacht waarschijnlijk dat 1 minuut = 40 seconden is. Maar 1 minuut = 60 seconden. Dus 60 + 23 = 83, niet 40 + 23 = 63. Onthoud: 1 minuut = 60 seconden.",
          "3": "Je dacht waarschijnlijk dat je 60 + 60 + 23 moet rekenen. Maar er is maar 1 minuut (01), niet 2. Dus 1 × 60 + 23 = 83. Onthoud: het eerste getal op de stopwatch zijn de minuten."
        }
      }
    },
    {
      "id": "MET-TIJD-METEN-002",
      "familyId": "MET-TIJD-METEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijd_meten",
      "subSkill": "tijd_meten_stopwatch",
      "questionType": "multiple_choice",
      "question": "Een kok zet een timer voor een zachtgekookt ei. Na 3 minuten en 15 seconden gaat het alarm af. Hoeveel seconden heeft het ei gekookt?",
      "options": ["315 seconden", "180 seconden", "195 seconden", "135 seconden"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten en seconden omrekenen",
            "content": "1 minuut = 60 seconden. Dus 3 minuten = 3 × 60 = 180 seconden. Plus 15 seconden = 195 seconden totaal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_meten_min_sec_omrekenen",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "3 minuten = 3 × 60 = 180 seconden. Plus 15 seconden = 180 + 15 = 195 seconden. Waarom ×60? Omdat er 60 seconden in 1 minuut gaan. Check: 195 ÷ 60 = 3 rest 15 → 3 min 15 sec ✓",
        "solutionSteps": [
          "Reken de minuten om: 3 × 60 = 180 seconden",
          "Tel de seconden erbij: 180 + 15 = 195 seconden",
          "Check: 195 ÷ 60 = 3 rest 15 → 3 min 15 sec ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de cijfers achter elkaar zet: 3-15 = 315. Maar je moet de minuten omrekenen naar seconden: 3 × 60 = 180. Dan 180 + 15 = 195. Onthoud: minuten × 60 + seconden.",
          "1": "Je dacht waarschijnlijk dat 3 minuten = 180 seconden en vergat de 15 seconden erbij te tellen. 180 is alleen de minuten — tel de 15 seconden er nog bij op. Onthoud: vergeet de losse seconden niet!",
          "2": "Goed! 3 × 60 + 15 = 195 seconden.",
          "3": "Je dacht waarschijnlijk dat 1 minuut = 45 seconden is. Maar 1 minuut = 60 seconden. Dus 3 × 60 = 180, niet 3 × 45 = 135. Onthoud: 1 minuut = 60 seconden."
        }
      }
    },
    {
      "id": "MET-TIJD-METEN-003",
      "familyId": "MET-TIJD-METEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijd_meten",
      "subSkill": "tijd_meten_stopwatch",
      "questionType": "multiple_choice",
      "question": "Lisa rent 3 rondjes om het veld. De stopwatch toont na elk rondje: 00:45, 01:32, 02:15. Hoe lang deed ze over het tweede rondje?",
      "options": ["45 seconden", "47 seconden", "32 seconden", "1 minuut 32 seconden"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tussentijden berekenen",
            "content": "De stopwatch toont de totale tijd. Voor het tweede rondje: trek de tijd van rondje 1 af van de tijd na rondje 2. 01:32 − 00:45 = 00:47.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_meten_tussentijd",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De stopwatch toont de totale tijd, niet de tijd per rondje. Rondje 2 = totaal na rondje 2 − totaal na rondje 1 = 01:32 − 00:45. Reken om: 92 sec − 45 sec = 47 seconden. Waarom aftrekken? Omdat de stopwatch doorloopt — je moet het verschil berekenen.",
        "solutionSteps": [
          "Totaal na rondje 1: 00:45 = 45 seconden",
          "Totaal na rondje 2: 01:32 = 92 seconden",
          "Rondje 2: 92 − 45 = 47 seconden",
          "Check: 45 + 47 = 92 sec = 01:32 ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat elk rondje 45 seconden duurt. Maar 00:45 is alleen de tijd van het eerste rondje. Het tweede rondje bereken je door af te trekken: 01:32 − 00:45 = 47 sec. Onthoud: de stopwatch toont totale tijd.",
          "1": "Goed! 01:32 − 00:45 = 47 seconden.",
          "2": "Je dacht waarschijnlijk dat de 32 in 01:32 de tijd van het tweede rondje is. Maar 01:32 is de totale tijd na twee rondjes. Trek de tijd van rondje 1 af: 92 − 45 = 47. Onthoud: tussentijd = verschil.",
          "3": "Je dacht waarschijnlijk dat 01:32 de tijd van het tweede rondje is. Maar dat is de totale tijd na twee rondjes. Het tweede rondje = 01:32 − 00:45 = 47 seconden. Onthoud: de stopwatch stopt niet tussen rondjes."
        }
      }
    },
    {
      "id": "MET-TIJD-METEN-004",
      "familyId": "MET-TIJD-METEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijd_meten",
      "subSkill": "tijd_meten_stopwatch",
      "questionType": "multiple_choice",
      "question": "Twee leerlingen rennen 60 meter. Pim doet er 11 seconden over, Sanne doet er 9 seconden over. Hoeveel seconden is Pim langzamer dan Sanne?",
      "options": ["1 seconde", "9 seconden", "11 seconden", "2 seconden"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijden vergelijken",
            "content": "Om te weten hoeveel langzamer iemand is, trek je de snelste tijd af van de langzaamste: 11 − 9 = 2 seconden verschil.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_meten_vergelijken",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Pim: 11 seconden. Sanne: 9 seconden. Het verschil: 11 − 9 = 2 seconden. Pim is 2 seconden langzamer. Waarom aftrekken? Omdat je het verschil wilt weten tussen twee tijden. Check: 9 + 2 = 11 ✓",
        "solutionSteps": [
          "Pim: 11 seconden, Sanne: 9 seconden",
          "Verschil: 11 − 9 = 2 seconden",
          "Pim is 2 seconden langzamer",
          "Check: 9 + 2 = 11 ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat het verschil kleiner is. Maar 11 − 9 = 2, niet 1. Misschien dacht je aan 10 − 9 = 1? Onthoud: gebruik de exacte tijden: 11 − 9 = 2 seconden.",
          "1": "Je dacht waarschijnlijk dat het antwoord de snelste tijd is. Maar 9 seconden is Sanne's tijd, niet het verschil. Het verschil: 11 − 9 = 2 seconden.",
          "2": "Je dacht waarschijnlijk dat het antwoord Pim's tijd is. Maar 11 seconden is hoe lang Pim deed, niet hoeveel langzamer hij is. Het verschil: 11 − 9 = 2 seconden.",
          "3": "Goed! 11 − 9 = 2 seconden verschil."
        }
      }
    },
    {
      "id": "MET-TIJD-METEN-005",
      "familyId": "MET-TIJD-METEN",
      "module": "Metriek",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijd_meten",
      "subSkill": "tijd_meten_stopwatch",
      "questionType": "fill_in",
      "question": "De stopwatch toont 02:15. Hoeveel seconden is dat in totaal? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["135", "135 seconden", "135 sec"],
        "caseSensitive": false,
        "placeholder": "... seconden"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten naar seconden",
            "content": "02:15 = 2 minuten en 15 seconden. 1 minuut = 60 seconden. Dus: 2 × 60 + 15 = 135 seconden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_meten_omrekenen",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "02:15 = 2 minuten en 15 seconden. 2 × 60 = 120 seconden. 120 + 15 = 135 seconden totaal. Waarom ×60? Omdat 1 minuut altijd 60 seconden is. Check: 135 ÷ 60 = 2 rest 15 → 2 min 15 sec ✓",
        "solutionSteps": [
          "Lees af: 2 minuten en 15 seconden",
          "Reken om: 2 × 60 = 120 seconden",
          "Tel op: 120 + 15 = 135 seconden",
          "Check: 135 ÷ 60 = 2 rest 15 ✓"
        ]
      }
    }
  ]
}